<template>
	<section id="hero" class="cover hero pb-3" :style="{ backgroundPosition: 'center '+headerHeight+'px' }">
		<b-container class="pb-4 position-relative">
			<b-row class="pb-6 align-items-end">
				<b-col cols="12" class="text-center">
					<h1 class="text-white text-uppercase font-weight-bold pt-6">Högsta kvalitet till bästa pris. <br>Hållbart hela vägen.</h1>
					<p class="pt-3 text-white">Hållbarhetsredovisning 2018/2019</p>
				</b-col>
			</b-row>
			<div class="position-absolute absolute-bottom absolute-left w-100 text-center">
				<a 	href="#about"
					v-scroll-to="{ el: '#about', offset: scrollOffset }"
					class="d-inline-block w-10">
					<img 	src="../assets/img/icons/arrow-down.svg"
							class="img-fluid transition-bounce-invert"
							width="50"
							height="53"
							alt="Gå till nästa sektion">
				</a>
			</div>
		</b-container>
	</section>
</template>
<script>
	export default {
		name: 'Hero',
		data () {
			return {
				headerHeight: 0,
				scrollOffset: 0
			}
		},
		methods: {
			handleResize (e) {
				this.headerHeight = document.getElementById('page-header').offsetHeight;
				this.scrollOffset = -this.headerHeight;
			}
		},
		created () {
			window.addEventListener('resize', this.handleResize);
		},
		mounted() {
			this.headerHeight = document.getElementById('page-header').offsetHeight;
			this.scrollOffset = -this.headerHeight;
		},
		beforeDestroy () {
			window.removeEventListener('resize', this.handleResize);
		}
	}
</script>
